import { Helmet } from 'react-helmet-async';
// sections
import Login from '../sections/auth/Login';

// ----------------------------------------------------------------------

type Props = {
  requiredPermission: string;
};

export default function LoginPage({ requiredPermission }: Props) {
  return (
    <>
      <Helmet>
        <title> Login | Kontrol Hub</title>
      </Helmet>

      <Login requiredPermission={requiredPermission} />
    </>
  );
}
